import React from 'react';

import { StyledNewTag } from './styled';

export const NewTag: React.FC = ({ children }) => {
  return <StyledNewTag>{children}</StyledNewTag>;
};
